import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
import { isEditorX, getAuthorizationToken } from '@wix/wix-vod-shared/common';
export class CatalogService {
    constructor(httpClient, baseUrlPath = '') {
        this.httpClient = httpClient;
        this.baseUrlPath = baseUrlPath;
    }
    get defaultOptions() {
        const defaultOptions = {
            baseURL: this.getBaseUrl(),
            xsrfCookieName: 'non-existing-cookie',
            withCredentials: true,
        };
        const authHeader = getAuthorizationToken();
        if (authHeader) {
            defaultOptions.headers = {
                ...(defaultOptions.headers ?? {}),
                Authorization: authHeader,
            };
        }
        return defaultOptions;
    }
    get baseOrigin() {
        return isEditorX()
            ? PRODUCTION_HOSTS.catalogEditorX
            : PRODUCTION_HOSTS.catalog;
    }
    getBaseUrl() {
        return this.baseOrigin + this.baseUrlPath;
    }
    getRelativeBasePath() {
        return this.getBaseUrl() ?? '';
    }
    async request(requestOptions) {
        return this.httpClient.request({
            baseURL: this.getBaseUrl(),
            ...this.defaultOptions,
            ...requestOptions,
        });
    }
    async post(url, data, requestOptions) {
        return this.httpClient.post(this.getRelativeBasePath() + url, data, {
            ...this.defaultOptions,
            ...requestOptions,
        });
    }
    async patch(url, data, requestOptions) {
        return this.httpClient.patch(this.getRelativeBasePath() + url, data, {
            ...this.defaultOptions,
            ...requestOptions,
        });
    }
    async put(url, data, requestOptions) {
        return this.httpClient.put(this.getRelativeBasePath() + url, data, {
            ...this.defaultOptions,
            ...requestOptions,
        });
    }
    async get(url, requestOptions) {
        return this.httpClient.get(this.getRelativeBasePath() + url, {
            ...this.defaultOptions,
            ...requestOptions,
        });
    }
    async delete(url, requestOptions) {
        return this.httpClient.delete(this.getRelativeBasePath() + url, {
            ...this.defaultOptions,
            ...requestOptions,
        });
    }
}
export class CatalogServiceBase extends CatalogService {
    constructor(httpClient, baseUrl, baseUrlPath) {
        super(httpClient, baseUrlPath);
        this.baseUrl = baseUrl;
    }
    getBaseUrl() {
        if (this.baseUrl === undefined) {
            return super.getBaseUrl();
        }
        try {
            return new URL(this.baseUrl).origin;
        }
        catch (err) {
            // the URL is relative, no need to set baseURL
            return undefined;
        }
    }
    getRelativeBasePath() {
        if (this.baseUrl === undefined) {
            return super.getRelativeBasePath();
        }
        try {
            return new URL(this.baseUrl).pathname;
        }
        catch (err) {
            // passed url is relative, so we just return it
            return this.baseUrl;
        }
    }
}
//# sourceMappingURL=catalog-service.js.map